export const isPortugueseStore = (country) => {
  if (typeof country !== 'string') return false;
  const value = country.trim();
  return value.localeCompare('PT', undefined, { sensitivity: 'accent' }) === 0
    || value.localeCompare('Portugal', undefined, { sensitivity: 'accent' }) === 0;
};
